import QrScanner from "qr-scanner";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useLocation, useNavigate } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import Config from "../../config/Config";
import { useAppSelector } from "../../core/feature/hooks";
import CustomApp from "../../core/models/customApp";
import User from "../../core/models/user";
import {
  comboStudentsClass,
  decodeQrCode,
  requestBooking,
  statusBooking,
  comboGrade,
} from "../../core/service/api_pickup_student";
import TabsMobile from "../__template/TabsMobileComponent";
import "./pickup.css";
import moment from "moment";
import { toast } from "react-toastify";
import { handleLongText } from "../../config/global";
import _, { set } from "lodash";
// import QrReader from "react-qr-scanner";
const PickupStudentBookingMobile = () => {
  const user: User = useAppSelector((state) => state.user.user);
  const [company, setCompany] = useState<any>({});
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const token: String = useAppSelector((state) => state.token.token);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isScanOpen, setIsScanOpen] = useState(false);
  const { t } = useTranslation();

  const [message, setMessage] = useState("");
  const [studentId, setStudentId] = useState("");
  const [startDate, setStartDate] = useState(
    moment().add(1, "days").format("yyyy-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().add(1, "days").format("yyyy-MM-DD")
  );
  const [students, setStudents] = useState<any>([]);
  const startDateRef = useRef<HTMLInputElement>(null);
  const endDateRef = useRef<HTMLInputElement>(null);
  const [grade, setgrade] = useState<any>("");
  const [gradeOptions, setgradeOptions] = useState<any>([]);

  useEffect(() => {
    // setCompany(JSON.parse(localStorage.getItem("company") || ""));
    // if (user == undefined) navigate("/login", { replace: true });
    // else {
    //   console.log(user?.accounts[0].callerIdentities);
    // }
    // getComboGrade();
    getComboStudent();
  }, []);

  useEffect(() => {
    if (location.pathname.split("/")[2] != undefined) {
    }
  }, [location.pathname.split("/")[2]]);

  useEffect(() => {
    if (grade) getComboStudent();
  }, [grade]);

  function closeScanModal() {
    setIsScanOpen(false);
  }

  const getComboGrade = async () => {
    let response = await comboGrade();
    setgradeOptions(response.data);
  };

  const getComboStudent = async () => {
    let query = [];
    query.push(`student_class=${grade}`);
    let response = await comboStudentsClass(query);
    console.log(response.data);
    setStudents(response.data);
  };

  const handleRefresh = async () => {};

  const submit = async () => {
    if (!studentId || !startDate || !endDate)
      return toast.warning(t("PICKUPSTUDENT.formNotFilled"));
    let newData = {
      studentId,
      startTime: startDate,
      endTime: endDate,
      message,
      std_class: _.find(students, { student_id: studentId }).student_class,
    };
    // alert(JSON.stringify(newData));
    try {
      let response = await requestBooking(newData);
      navigate(
        `/pickup-student/status/${
          response.data.pickupId || response.data.id || response.data._id
        }`
      );
    } catch (error) {
    } finally {
    }
  };

  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        {/* <div className="bg-white px-8 pt-8 pb-3  sticky top-0 z-50">
          <TabsMobile
            name={`${t("PICKUPSTUDENT.bookingTitle")}`}
            backUrl={"pickup-student"}
          ></TabsMobile>
        </div> */}
        <PullToRefresh className="text-center" onRefresh={handleRefresh}>
          <div className="text-left h-[calc(100vh-136px)]  px-4 py-6 bg-psp-primary top-to-bottom font-montserrat">
            <section className="mt-1 w-full h-full">
              <div className="flex flex-col gap-2 w-full h-[calc(100vh-250px)] justify-start items-center bg-white rounded-xl cursor-pointer">
                {/* <form className="pt-3 w-4/5">
                  <label className="text-lg">{t("PICKUPSTUDENT.grade")}</label>
                  <br />
                  <select
                    value={grade}
                    onChange={(e) => {
                      setStudentId("");
                      setgrade(e.target.value);
                    }}
                    className="py-3 px-3 w-full border rounded-lg disabled:text-gray-500"
                  >
                    <option disabled value="">
                      pilih
                    </option>
                    ;
                    {gradeOptions.map((el: any) => {
                      return <option value={el.name}>{el.name}</option>;
                    })}
                  </select>
                </form> */}
                <form className="pt-3 w-4/5">
                  <label className="text-lg">
                    {t("PICKUPSTUDENT.account")}
                  </label>
                  <br />
                  <select
                    // disabled={!grade}
                    value={studentId}
                    onChange={(e) => setStudentId(e.target.value)}
                    className="py-3 px-3 w-full border rounded-lg disabled:text-gray-500"
                  >
                    <option disabled value="">
                      pilih
                    </option>
                    ;
                    {students.map((el: any) => {
                      return (
                        <option
                          value={el.student_id}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span className="w-32 flex items-center">
                            {`${el.student_nis} - ${
                              el.student_class
                            } - ${handleLongText(el.student_name, 20)}`}
                          </span>
                        </option>
                      );
                    })}
                  </select>
                </form>{" "}
                <form className="pt-3 w-4/5">
                  <label className="text-lg">
                    {t("PICKUPSTUDENT.startDate")}
                  </label>
                  <br />
                  <input
                    type="date"
                    value={startDate}
                    ref={startDateRef}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="py-3 px-3 w-full border rounded-lg disabled:text-gray-500"
                  ></input>
                </form>
                <form className="pt-3 w-4/5">
                  <label className="text-lg">
                    {t("PICKUPSTUDENT.endDate")}
                  </label>
                  <br />
                  <input
                    type="date"
                    value={endDate}
                    ref={endDateRef}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="py-3 px-3 w-full border rounded-lg disabled:text-gray-500"
                  ></input>
                </form>
                <form className="pt-3 w-4/5">
                  <label className="text-lg">
                    {t("PICKUPSTUDENT.message")}
                  </label>
                  <br />
                  <textarea
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="py-3 px-3 w-full border rounded-lg disabled:text-gray-500"
                  ></textarea>
                </form>
                <form className="pt-3 w-4/5 flex justify-end">
                  <button
                    type="button"
                    onClick={submit}
                    className=" bg-[#FEB139] py-2 px-3 font-bold text-white rounded-xl "
                  >
                    request
                  </button>
                </form>
              </div>
            </section>
          </div>
        </PullToRefresh>
      </div>
    </>
  );
};

export default PickupStudentBookingMobile;
